import { render, staticRenderFns } from "./PushMailPage.vue?vue&type=template&id=9aefb490&scoped=true&"
import script from "./PushMailPage.vue?vue&type=script&lang=js&"
export * from "./PushMailPage.vue?vue&type=script&lang=js&"
import style0 from "./PushMailPage.vue?vue&type=style&index=0&id=9aefb490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aefb490",
  null
  
)

export default component.exports